module.exports = {
  // SERVER_URL: "http://192.168.30.136:3500/api/"//dev 
  // SERVER_URL: "http://192.168.30.122:5200/api/"//IP
  SERVER_URL: "https://api.phongsavanhgroup.com/api/" // production
};
